<template>
  <div
    :is="type"
    @touchstart="touchStart"
    @touchend="touchStop"
    @touchcancel="touchStop"
    @touchmove="touchStop"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LongTouch',
  props: {
    type: {
      type: String,
      default: 'div'
    }
  },
  data(){
    return {
      tap: false,
      stop: false
    }
  },
  mounted(){
    this.$timer = null
  },
  methods: {
    touchStart(e){
      // console.log('touchStart', e)
      if(!this.tap){
        this.tap = true
        this.$timer = setTimeout(()=>{
          if(this.tap){
            // let event = new CustomEvent('touchlong', Object.assign({}, e, e.changedTouches[0]))
            // e.type = 'touchlong'
            e.clientX = e.changedTouches[0].clientX
            e.clientY = e.changedTouches[0].clientY
            console.log('emit-touchlong', e)
            this.$emit('touchlong', e)
          }
        }, 600)
      }
    },
    touchStop(e){
      // console.log('touchStop', e.type)
      if(this.tap){
        this.tap = false
        if(this.$timer){
          clearTimeout(this.$timer)
          this.$timer = null
        }
      }
    }
  }
}
</script>

<style>
</style>
